/**
 * Handles optimistic teacher check-in + API sync.
 * Extracted so AppRouter stays focused on routing only.
 */
import { toast } from "sonner";

export function useTeacherCheckIn(user, teachData, setTeachData, patchUser) {
  const handleTeacherCheckIn = async (userId, time, loc) => {
    // Optimistic update
    setTeachData((prev) =>
      prev.map((t) =>
        t.userId === userId ||
        t.userObjectId === user?._id ||
        t.userObjectId === user?.id
          ? {
              ...t,
              checkInTime: time,
              checkInLoc: loc,
              attendanceStatus: "present",
              checkInDate: new Date().toISOString(),
            }
          : t
      )
    );
    patchUser({ checkInTime: time, checkInLoc: loc });

    try {
      const teacherDocId = user?.teacherDocId;
      const teacher = teacherDocId
        ? teachData.find((t) => (t._id || t.id) === teacherDocId)
        : teachData.find(
            (t) =>
              t.userId === userId ||
              t.userObjectId === user?._id ||
              t.userObjectId === user?.id
          );
      const tid = teacher?._id || teacher?.id || teacherDocId;

      if (tid) {
        const result = await import("../api/teachers").then((m) =>
          m.default.checkin(tid, { time, location: loc })
        );
        
        if (result?.success || result?.status) {
          toast.success(`Checked in at ${time}`);
          if (result?.status) {
            setTeachData((prev) =>
              prev.map((t) =>
                (t._id || t.id) === tid ? { ...t, attendanceStatus: result.status } : t
              )
            );
          }
        } else {
          toast.success(`Checked in at ${time}`);
        }
      } else {
        toast.success(`Checked in at ${time}`);
      }
    } catch (err) {
      // Optimistic update already applied — API failure is non-critical
      console.error("Check-in API error:", err);
      toast.error("Check-in saved locally but sync failed");
    }
  };

  return { handleTeacherCheckIn };
}